module.exports = __webpack_public_path__ + "static/media/tv.fdc31e33.svg";